(() => {
const root = window.Shopify?.routes?.root || '/';
document.addEventListener('submit', async event => {
 const form = event.target.closest('[data-elara-pair-form]');
 if (!form) return;
 event.preventDefault();
 if (!form.reportValidity()) return;
 const button = form.querySelector('button[type="submit"]');
 const status = form.querySelector('[data-pair-status]');
 if (button.disabled) return;
 const labels = button.textContent;
 button.disabled = true; button.textContent = form.dataset.adding;
 status.textContent = '';
 try {
  const selections = Array.from(form.querySelectorAll('select'));
  const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:selections.map(select=>({id:Number(select.value),quantity:1}))})});
  const data = await response.json();
  if (!response.ok) throw new Error(data.description || form.dataset.error);
  status.textContent = form.dataset.success;
  window.location.assign(form.dataset.cartUrl || root + 'cart');
 } catch(error) {status.textContent = error.message || form.dataset.error;button.disabled=false;button.textContent=labels;}
});
const updateProgress = cart => {
 if (cart.currency !== 'USD') return;
 document.querySelectorAll('[data-elara-shipping-progress]').forEach(box => {
  const amount = Math.max(0,10000-cart.total_price);
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:'USD'}).format(amount/100);
  box.querySelector('[data-shipping-progress-text]').textContent = amount ? box.dataset.remaining.replace('__AMOUNT__',money) : box.dataset.qualified;
  box.querySelector('progress').value = Math.min(10000,Math.max(0,cart.total_price));
 });
};
let timer;
const refresh = () => {clearTimeout(timer);timer=setTimeout(async()=>{if(!document.querySelector('[data-elara-shipping-progress]'))return;try{const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});if(response.ok)updateProgress(await response.json());}catch(error){}},100);};
const initialize=()=>{
 refresh();
 new MutationObserver(records=>{if(records.some(record=>Array.from(record.addedNodes).some(node=>node.nodeType===1&&(node.matches?.('[data-elara-shipping-progress]')||node.querySelector?.('[data-elara-shipping-progress]')))))refresh();}).observe(document.body,{childList:true,subtree:true});
 if(window.jQuery)window.jQuery(document.body).on('afterCartLoad.ajaxCart',refresh);
 document.addEventListener('cart:updated',refresh);
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
})();